var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.00098,
    cy: 128.00049,
    r: 56,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.001,120.001l10.30713-15.4603a8.18367,8.18367,0,0,0,1.07094-6.86806,103.18961,103.18961,0,0,0-7.652-18.50824,8.14437,8.14437,0,0,0-5.60531-4.08483l-18.23792-3.64791L184.57031,60.11816l-3.64788-18.23862a8.14452,8.14452,0,0,0-4.08517-5.60564,103.21306,103.21306,0,0,0-18.50891-7.65085,8.18366,8.18366,0,0,0-6.868,1.07071L136.001,40h-16L104.54162,29.69376a8.18369,8.18369,0,0,0-6.868-1.07071,103.21412,103.21412,0,0,0-18.50876,7.65077,8.1445,8.1445,0,0,0-4.08522,5.60591l-3.647,18.23746L60.11816,71.43164l-18.23762,3.647a8.14428,8.14428,0,0,0-5.60569,4.08493,103.19818,103.19818,0,0,0-7.652,18.50915,8.18354,8.18354,0,0,0,1.0709,6.86786L40,120v16L29.6937,151.45945a8.18369,8.18369,0,0,0-1.07072,6.86784,103.1749,103.1749,0,0,0,7.65075,18.50925,8.1448,8.1448,0,0,0,5.60561,4.08487l18.23882,3.64793,11.31348,11.31347,3.64709,18.2387a8.14473,8.14473,0,0,0,4.08479,5.60582A103.14826,103.14826,0,0,0,97.672,227.37827a8.18362,8.18362,0,0,0,6.86744-1.07079L120,216.001h16l15.46031,10.30714a8.18353,8.18353,0,0,0,6.868,1.07073,103.18533,103.18533,0,0,0,18.5082-7.65063,8.14479,8.14479,0,0,0,4.08487-5.6056l3.64793-18.23883,11.31347-11.31445,18.23862-3.64708a8.14431,8.14431,0,0,0,5.6057-4.08491,103.18916,103.18916,0,0,0,7.65192-18.508,8.18367,8.18367,0,0,0-1.07094-6.86806L216.001,136.001Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.dcae1240bef11d1d79c223393898084d.svg";
export { ForwardRef as ReactComponent };